module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_6000.811cd2a9.png";